'use client';

import { Chip, Tooltip } from '@heroui/react';
import { FaLightbulb } from 'react-icons/fa6';

type ConfidenceChipProps = {
  confidence: number;
  reason?: string;
  showTooltip?: boolean;
};

const getConfidenceColor = (confidence: number) => {
  if (confidence >= 80) return 'success';
  if (confidence >= 60) return 'primary';
  if (confidence >= 40) return 'warning';
  return 'default';
};

const getConfidenceLabel = (confidence: number) => {
  if (confidence >= 80) return 'Highly Recommended';
  if (confidence >= 60) return 'Recommended';
  if (confidence >= 40) return 'Consider';
  return 'Optional';
};

export default function ConfidenceChip({
  confidence,
  reason,
  showTooltip = true,
}: ConfidenceChipProps) {
  const chip = (
    <Chip
      color={getConfidenceColor(confidence)}
      size='sm'
      variant='flat'
      endContent={<FaLightbulb className='text-xs' />}
    >
      {getConfidenceLabel(confidence)}
    </Chip>
  );

  if (showTooltip && reason) {
    return (
      <Tooltip
        content={
          <div className='max-w-xs p-2'>
            <p className='text-xs'>{reason}</p>
          </div>
        }
        delay={300}
        closeDelay={100}
        placement='top'
        color='foreground'
        showArrow
      >
        {chip}
      </Tooltip>
    );
  }

  return chip;
}

export { getConfidenceColor, getConfidenceLabel };


